import styled from "styled-components"
import mainTheme from "../../global/theme"

export default styled.div`
  background: linear-gradient(360deg, white, rgba(255, 255, 255, 0.4));
  min-height: 40px;
  padding: ${mainTheme.spacing.half} ${mainTheme.spacing.two};
  display: flex;
  align-items: center;
  border: 1px solid ${mainTheme.colors.utility.subdued};
  border-top: 0;
  z-index: 100;
  overflow-y: hidden;
  overflow-x: auto;
`
